import { z } from 'zod';

/** Hours per purchase: positive with at most two decimal places, matching the server rules. */
const hoursSchema = z
  .number({ message: 'Hours must be a number' })
  .positive('Hours must be greater than 0')
  .max(99999999.99, 'Hours is too large')
  .refine((value) => Math.round(value * 100) / 100 === value, {
    message: 'Hours may have at most two decimal places',
  });

/**
 * Schema for the editable fields of a consultant hour package.
 */
export const consultantHourPackageSchema = z.object({
  displayName: z.string().trim().min(1, 'Name is required').max(200, 'Name is too long'),
  hours: hoursSchema,
  sortOrder: z
    .number({ message: 'Sort order must be a number' })
    .int('Sort order must be a whole number'),
});

/**
 * Schema for creating a consultant hour package: the editable fields plus the Stripe price.
 */
export const createConsultantHourPackageSchema = consultantHourPackageSchema.extend({
  stripePriceId: z.string().min(1, 'Select a Stripe price'),
});

/**
 * TypeScript types inferred from schemas
 */
export type ConsultantHourPackageForm = z.infer<typeof consultantHourPackageSchema>;
export type CreateConsultantHourPackageForm = z.infer<typeof createConsultantHourPackageSchema>;
